import { unwrapEnvelope } from "@/api/errors";
import { platformGraph } from "@/api/platform-graph";
import type { paths } from "@/api/schema.generated";
export type SearchData = paths["/v1/search"]["get"]["responses"][200]["content"]["application/json"]["data"];
export const searchRecords = (q: string, signal?: AbortSignal): Promise<SearchData> => unwrapEnvelope(platformGraph.GET("/v1/search", { params: { query: { q, limit: 5 } }, ...(signal === undefined ? {} : { signal }) }));
